module.exports = __webpack_public_path__ + "static/media/window-close.0334c02e.svg";